// extracted by mini-css-extract-plugin
export default {"comfortBuy":"VXw6Q","advantagesList":"Yxzqm","advantagesItem":"lZZdZ","advantagesPic":"ZGBLZ","cnImage":"qw4Ii","heading":"zZDVE","description":"YYg5K","note":"qlUAg"};